import { baseApiSlice } from '../../commons/base-api.config';
import {
    API_MARK_PROJECT_AS_TEMPLATE,
    API_GET_ORGANIZATION_TEMPLATES,
    API_PRESIGN_TEMPLATE,
} from '../../constants/api';
import { HTTP_METHODS } from '../../constants/http';
import { ITemplate } from '../../interfaces/campaign.interface';
import {
    IMarkProjectAsTemplateRequestpayload,
    IPresignTemplateRequestpayload,
} from '../../pages/Apprentice/apprentice.interface';

export const templateApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            getOrganizationTemplates: builder.query<ITemplate[], number>({
                query(organizationId) {
                    return {
                        url: `${API_GET_ORGANIZATION_TEMPLATES}/?organizationId=${organizationId}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                providesTags: ['brandTemplates'],
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            markProjectAsTemplate: builder.mutation<any, IMarkProjectAsTemplateRequestpayload>({
                query: (data) => {
                    return {
                        url: API_MARK_PROJECT_AS_TEMPLATE,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                invalidatesTags: ['brandTemplates'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            presignTemplate: builder.mutation<any, IPresignTemplateRequestpayload>({
                query: (data) => {
                    return {
                        url: API_PRESIGN_TEMPLATE,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
        };
    },
});

export const {
    useGetOrganizationTemplatesQuery,
    useMarkProjectAsTemplateMutation,
    usePresignTemplateMutation,
} = templateApiSlice;
